import React from 'react'
import {Select} from 'antd'
import jobCrawlerSources from '../static/jobCrawlerSources'

const {Option} = Select

function JobCrawlersFilter({source, onChange}) {
    return (
        <div className="TrackingFilter">
            <div className="ListFilter">
                <div className="Filters">
                    <label>Source</label>
                    <Select
                        allowClear
                        placeholder="All sources"
                        value={source}
                        onChange={onChange}
                    >
                        {jobCrawlerSources.map(s => (
                            <Option key={s.value} value={s.value}>{s.label}</Option>
                        ))}
                    </Select>
                </div>
            </div>
        </div>
    )
}

export default JobCrawlersFilter
